import request from 'utils/request';

const PREFIX = '[ADVOCACY_REPORTS]';

export const FETCH_REPORTS_SCHEMA_REQUEST = `${PREFIX} FETCH_REPORTS_SCHEMA_REQUEST`;
export const FETCH_REPORTS_SCHEMA_SUCCESS = `${PREFIX} FETCH_REPORTS_SCHEMA_SUCCESS`;
export const FETCH_REPORTS_SCHEMA_FAILURE = `${PREFIX} FETCH_REPORTS_SCHEMA_FAILURE`;

const fetchReportsSchemaRequest = () => ({
  type: FETCH_REPORTS_SCHEMA_REQUEST,
});

const fetchReportsSchemaSuccess = payload => ({
  payload,
  type: FETCH_REPORTS_SCHEMA_SUCCESS,
});

const fetchReportsSchemaFailure = payload => ({
  payload,
  type: FETCH_REPORTS_SCHEMA_FAILURE,
});

export const fetchReportsSchema = organizationUuid => dispatch => {
  dispatch(fetchReportsSchemaRequest());

  return request
    .get(`/v1/campaigns/reports/schema/?organization=${organizationUuid}`)
    .then(({ data }) => {
      dispatch(fetchReportsSchemaSuccess(data));

      return data;
    })
    .catch(({ response: { data } = {} }) => {
      dispatch(fetchReportsSchemaFailure(data));

      throw data;
    });
};

export const POST_ACTION_CENTER_ADVOCACY_MESSAGE_REPORT = `${PREFIX} POST_ACTION_CENTER_ADVOCACY_MESSAGE_REPORT`;
export const POST_ACTION_CENTER_ADVOCACY_MESSAGE_REPORT_SUCCESS = `${PREFIX} POST_ACTION_CENTER_ADVOCACY_MESSAGE_REPORT_SUCCESS`;
export const POST_ACTION_CENTER_ADVOCACY_MESSAGE_REPORT_FAILURE = `${PREFIX} POST_ACTION_CENTER_ADVOCACY_MESSAGE_REPORT_FAILURE`;

const postCampaignActionCenterAdvocacyMessageReport = () => ({
  type: POST_ACTION_CENTER_ADVOCACY_MESSAGE_REPORT,
});

const postCampaignActionCenterAdvocacyMessageReportSuccess = payload => ({
  payload,
  type: POST_ACTION_CENTER_ADVOCACY_MESSAGE_REPORT_SUCCESS,
});

const postCampaignActionCenterAdvocacyMessageReportFailure = payload => ({
  payload,
  type: POST_ACTION_CENTER_ADVOCACY_MESSAGE_REPORT_FAILURE,
});

export const postActionCenterAdvocacyMessageReport = (params, organization_uuid) => dispatch => {
  dispatch(postCampaignActionCenterAdvocacyMessageReport());

  return request
    .post(`/v1/campaigns/reports/actioncenter-messages/?organization=${organization_uuid}`, params)
    .then(({ data }) => {
      dispatch(postCampaignActionCenterAdvocacyMessageReportSuccess(data));

      return data;
    })
    .catch(({ response: { data } = {} }) => {
      dispatch(postCampaignActionCenterAdvocacyMessageReportFailure(data));

      throw data;
    });
};

export const POST_ACTION_CENTER_ADVOCACY_ANALYTICS_REPORT = `${PREFIX} POST_ACTION_CENTER_ADVOCACY_ANALYTICS_REPORT`;
export const POST_ACTION_CENTER_ADVOCACY_ANALYTICS_REPORT_SUCCESS = `${PREFIX} POST_ACTION_CENTER_ADVOCACY_ANALYTICS_REPORT_SUCCESS`;
export const POST_ACTION_CENTER_ADVOCACY_ANALYTICS_REPORT_FAILURE = `${PREFIX} POST_ACTION_CENTER_ADVOCACY_ANALYTICS_REPORT_FAILURE`;

const postCampaignActionCenterAdvocacyAnalyticsReport = () => ({
  type: POST_ACTION_CENTER_ADVOCACY_ANALYTICS_REPORT,
});

const postCampaignActionCenterAdvocacyAnalyticsReportSuccess = payload => ({
  payload,
  type: POST_ACTION_CENTER_ADVOCACY_ANALYTICS_REPORT_SUCCESS,
});

const postCampaignActionCenterAdvocacyAnalyticsReportFailure = payload => ({
  payload,
  type: POST_ACTION_CENTER_ADVOCACY_ANALYTICS_REPORT_FAILURE,
});

export const postActionCenterAdvocacyAnalyticsReport = (params, organization_uuid) => dispatch => {
  dispatch(postCampaignActionCenterAdvocacyAnalyticsReport());

  return request
    .post(`/v1/campaigns/reports/actioncenter-analytics/?organization=${organization_uuid}`, params)
    .then(({ data }) => {
      dispatch(postCampaignActionCenterAdvocacyAnalyticsReportSuccess(data));

      return data;
    })
    .catch(({ response: { data } = {} }) => {
      dispatch(postCampaignActionCenterAdvocacyAnalyticsReportFailure(data));

      throw data;
    });
};

export const POST_CAMPAIGN_MESSAGES_REPORT = `${PREFIX} POST_CAMPAIGN_MESSAGES_REPORT`;
export const POST_CAMPAIGN_MESSAGES_REPORT_SUCCESS = `${PREFIX} POST_CAMPAIGN_MESSAGES_REPORT_SUCCESS`;
export const POST_CAMPAIGN_MESSAGES_REPORT_FAILURE = `${PREFIX} POST_CAMPAIGN_MESSAGES_REPORT_FAILURE`;

const postCampaignMessagesReport = () => ({
  type: POST_CAMPAIGN_MESSAGES_REPORT,
});

const postCampaignMessagesReportSuccess = payload => ({
  payload,
  type: POST_CAMPAIGN_MESSAGES_REPORT_SUCCESS,
});

const postCampaignMessagesReportFailure = payload => ({
  payload,
  type: POST_CAMPAIGN_MESSAGES_REPORT_FAILURE,
});

export const postCampaignMessagesReportAction = (params, organization_uuid) => dispatch => {
  dispatch(postCampaignMessagesReport());

  return request
    .post(`/v1/campaigns/reports/campaign-messages/?organization=${organization_uuid}`, params)
    .then(({ data }) => {
      dispatch(postCampaignMessagesReportSuccess(data));

      return data;
    })
    .catch(({ response: { data } = {} }) => {
      dispatch(postCampaignMessagesReportFailure(data));

      throw data;
    });
};

export const POST_CAMPAIGN_ANALYTICS_REPORT = `${PREFIX} POST_CAMPAIGN_ANALYTICS_REPORT`;
export const POST_CAMPAIGN_ANALYTICS_REPORT_SUCCESS = `${PREFIX} POST_CAMPAIGN_ANALYTICS_REPORT_SUCCESS`;
export const POST_CAMPAIGN_ANALYTICS_REPORT_FAILURE = `${PREFIX} POST_CAMPAIGN_ANALYTICS_REPORT_FAILURE`;

const postCampaignAnalyticsReport = () => ({
  type: POST_CAMPAIGN_ANALYTICS_REPORT,
});

const postCampaignAnalyticsReportSuccess = payload => ({
  payload,
  type: POST_CAMPAIGN_ANALYTICS_REPORT_SUCCESS,
});

const postCampaignAnalyticsReportFailure = payload => ({
  payload,
  type: POST_CAMPAIGN_ANALYTICS_REPORT_FAILURE,
});

export const postCampaignAnalyticsReportAction = (params, organization_uuid) => dispatch => {
  dispatch(postCampaignAnalyticsReport());

  return request
    .post(`/v1/campaigns/reports/campaign-analytics/?organization=${organization_uuid}`, params)
    .then(({ data }) => {
      dispatch(postCampaignAnalyticsReportSuccess(data));

      return data;
    })
    .catch(({ response: { data } = {} }) => {
      dispatch(postCampaignAnalyticsReportFailure(data));

      throw data;
    });
};

export const POST_ORGANIZATION_ADVOCACY_ANALYTICS_REPORT = `${PREFIX} POST_ORGANIZATION_ADVOCACY_ANALYTICS_REPORT`;
export const POST_ORGANIZATION_ADVOCACY_ANALYTICS_REPORT_SUCCESS = `${PREFIX} POST_ORGANIZATION_ADVOCACY_ANALYTICS_REPORT_SUCCESS`;
export const POST_ORGANIZATION_ADVOCACY_ANALYTICS_REPORT_FAILURE = `${PREFIX} POST_ORGANIZATION_ADVOCACY_ANALYTICS_REPORT_FAILURE`;

const postOrganizationAdvocacyAnalyticsReport = () => ({
  type: POST_ORGANIZATION_ADVOCACY_ANALYTICS_REPORT,
});

const postOrganizationAdvocacyAnalyticsReportSuccess = payload => ({
  payload,
  type: POST_ORGANIZATION_ADVOCACY_ANALYTICS_REPORT_SUCCESS,
});

const postOrganizationAdvocacyAnalyticsReportFailure = payload => ({
  payload,
  type: POST_ORGANIZATION_ADVOCACY_ANALYTICS_REPORT_FAILURE,
});

// eslint-disable-next-line max-len
export const postOrganizationAdvocacyAnalyticsReportAction =
  (params, organization_uuid) => dispatch => {
    dispatch(postOrganizationAdvocacyAnalyticsReport());

    return request
      .post(
        `/v1/campaigns/reports/organization-analytics/?organization=${organization_uuid}`,
        params
      )
      .then(({ data }) => {
        dispatch(postOrganizationAdvocacyAnalyticsReportSuccess(data));

        return data;
      })
      .catch(({ response: { data } = {} }) => {
        dispatch(postOrganizationAdvocacyAnalyticsReportFailure(data));

        throw data;
      });
  };
